import React from 'react'
import './Header.css'

export const Header = () => {
    return (
        <header>
            <h1>New Albums & singles</h1>
        </header>
    )   

}
